import React, { useEffect } from 'react';
import { getImageUrl } from '../utils/imageUrl';
import './SubmissionModal.css';

function SubmissionModal({ submission, platform, onClose }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  if (!submission) return null;

  const details = {
    youtube: {
      title: submission.channel_title,
      description: submission.channel_description,
      metricLabel: 'Subscribers',
      metric: submission.subscribers,
      url: submission.channel_url,
      linkLabel: 'Visit Channel'
    },
    instagram: {
      title: submission.account_name,
      description: submission.account_description,
      metricLabel: 'Followers',
      metric: submission.followers,
      url: submission.instagram_url,
      linkLabel: 'Visit Instagram'
    },
    blog: {
      title: submission.blog_title,
      description: submission.blog_description,
      metricLabel: 'Views per Month',
      metric: submission.views_per_month,
      url: submission.blog_url,
      linkLabel: 'Visit Blog'
    }
  }[platform];

  let photos = [];
  try {
    photos = submission.photos ? JSON.parse(submission.photos) : [];
  } catch (error) {
    photos = [];
  }

  return (
    <div className="submission-modal-backdrop" onClick={onClose} role="presentation">
      <section
        className="submission-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="submission-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button className="submission-modal-close" onClick={onClose} aria-label="Close details">×</button>
        <p className="submission-modal-platform">{platform} opportunity</p>
        <h2 id="submission-modal-title">{details.title}</h2>
        <div className="submission-modal-meta">
          <span><strong>{details.metricLabel}:</strong> {details.metric || 'Not provided'}</span>
          {submission.niche && <span><strong>Niche:</strong> {submission.niche}</span>}
          {submission.location && <span><strong>Location:</strong> {submission.location}</span>}
        </div>
        {photos.length > 0 && (
          <div className={`submission-modal-photos ${photos.length === 1 ? 'single-photo' : ''}`}>
            {photos.map((photo, index) => (
              <img key={index} src={getImageUrl(photo)} alt={`${details.title} ${index + 1}`} />
            ))}
          </div>
        )}
        <div className="submission-modal-description">
          <h3>About this listing</h3>
          <p>{details.description || 'No description provided.'}</p>
        </div>
        <div className="submission-modal-contact">
          <strong>Contact:</strong> {submission.email || 'Not provided'}
        </div>
        {details.url && (
          <a
            href={details.url}
            target="_blank"
            rel="noopener noreferrer"
            className="submission-modal-link"
            onClick={(event) => event.stopPropagation()}
          >
            {details.linkLabel} <span aria-hidden="true">↗</span>
          </a>
        )}
      </section>
    </div>
  );
}

export default SubmissionModal;